'use client'

import cn from 'clsx'

import { NavLink, Loading } from 'shared-components'

import ArrowNorthEast from '../../images/arrow-north-east'

import s from './Button.module.sass'

interface ButtonProps {
    url?: string
    title?: string
    handleClick?: () => void
    className?: string
    type?: string
    prefetch?: boolean
    label?: string
    inverted?: boolean
    search?: boolean
    capitalize?: boolean
    noBorder?: boolean
    transparent?: boolean
    noArrow?: boolean
    small?: boolean
    loading?: boolean
    brightBlue?: boolean
    deepNavy?: boolean
    skyBlue?: boolean
}

export default function Button({
    url,
    title,
    handleClick,
    className,
    type,
    prefetch,
    label,
    inverted,
    noBorder,
    transparent,
    noArrow,
    small,
    loading,
    brightBlue = false,
    deepNavy = false,
    skyBlue = false,
}: ButtonProps) {
    const handleDummyClick = () => {
        return
    }

    const _handleClick = handleClick || handleDummyClick

    const buttonClass = cn(
        s.Button,
        'button',
        className && className,
        inverted && s.Inverted,
        noBorder && s.NoBorder,
        transparent && s.Transparent,
        small && s.Small,
        brightBlue && s.BrightBlue,
        deepNavy && s.DeepNavy,
        skyBlue && s.SkyBlue,
    )

    const inner = (
        <>
            <span>{title}</span>
            {!noArrow && ArrowNorthEast}
        </>
    )

    if (!url) {
        return (
            <button
                className={buttonClass}
                onClick={_handleClick}
                type={type === 'submit' ? 'submit' : type === 'reset' ? 'reset' : 'button'}
                aria-label={label || 'Button'}
            >
                {inner}
                {loading && (
                    <div className={s.Loading}>
                        <Loading />
                    </div>
                )}
            </button>
        )
    }

    return (
        <NavLink className={buttonClass} href={url} prefetch={prefetch} onClick={_handleClick} label={label}>
            {inner}
            {loading && (
                <div className={s.Loading}>
                    <Loading />
                </div>
            )}
        </NavLink>
    )
}
